import { z } from 'zod';

export const loginSchema = z.object({
  cedula: z.string().trim().min(1, 'Ingrese su número de cédula.'),
  clave: z.string().trim().min(1, 'Ingrese su contraseña.'),
});

export type LoginValues = z.infer<typeof loginSchema>;
